import React, { useEffect, useState } from "react";
import { Table, Button, Form, InputGroup, Alert, Row, Col, Modal } from "react-bootstrap";
import axiosInstance from "../../../api/api";
import { Spinner } from "@themesberg/react-bootstrap";
import TextWhitTooltip from "../Util/TextWhitTooltip";
import CurrencyInput from "../Util/CurrencyInput";


const CostosFijosTable = ({ optionName, ciemId }) => {
    const [ciffList, setCiffList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [newCiff, setNewCiff] = useState({ rubro: '', valor: '' });

    useEffect(() => {
        inicializar();
        fetchCiffList();
    }, []);

    const fetchCiffList = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get('/ciff/' + ciemId.ciemId + '/' + optionName); // <-- Ajusta esta ruta
            setCiffList(response.data.data);
            const tableHeader = await axiosInstance.get('/detailoption/option/value/' + optionName);
            setTableHeaders(tableHeader.data.data);
            console.log("tabla empleado")
            console.log(tableHeader)
        } catch (error) {
            console.error('Error al cargar:', error);
            alert('Error al cargar los datos');
        } finally {
            setLoading(false);
        }
    };

    const inicializar = () => {
        try {
            axiosInstance.post('/ciff/inicializar/' + ciemId.ciemId + '/' + optionName); // <-- Ajusta esta ruta
            //setCiffList(response.data);
        } catch (error) {
            console.error('No se pudo inicializar:', error);
            alert('Error inicializando datos');
        } finally {
            setLoading(false);
        }
    }

    const handleValueChange = (name, value) => {
        const updatedList = ciffList.map(c => {
            if (c.name === name) {
                return { ...c, valor: value }; // Retorna una copia actualizada
            }
            return c; // Retorna el original si no coincide
        });
        setCiffList(updatedList); // Actualiza el estado con la nueva lista
    };

    const handleSave = async () => {
        try {
            console.log(ciffList)
            await axiosInstance.post('/ciff/' + optionName, ciffList); // <-- Ajusta esta ruta
            fetchCiffList();
            alert('Guardado correctamente');
        } catch (error) {
            console.error('Error al guardar:', error);
            alert('Error al guardar los datos');
        }
    };

    const handleAddNew = async () => {
        if (!newCiff.rubro.trim() || isNaN(parseFloat(newCiff.valor))) {
            alert('Debe ingresar un rubro y un valor numérico válido');
            return;
        }

        try {
            const response = await axiosInstance.post('/ciff/', {
                rubro: newCiff.rubro,
                name: newCiff.rubro, // El backend puede manejar `name` igual a `rubro` si se necesita
                valor: parseFloat(newCiff.valor),
                type: optionName,
                orden: ciffList.length - 3,
                ciem: ciemId.ciemId
            });
            setCiffList([...ciffList, response.data]);
            setNewCiff({ rubro: '', valor: '' });
            await handleSave();
            setShowModal(false);
        } catch (error) {
            console.error('Error al agregar nuevo:', error);
            alert('No se pudo agregar el nuevo rubro');
        }
    };

    if (loading) return <Spinner animation="border" />;

    return (
        <>
            <Table bordered>
                <thead>
                    <tr>
                        <th>Rubro</th>
                        <th>Valor</th>
                    </tr>
                </thead>
                <tbody>
                    {ciffList // 1. ordenar por orden
                        .map((item, index) => {
                            // 2. buscar el ciff correspondiente por name === value (ajusta si es otro campo)
                            const header = tableHeaders.find(c => c.value === item.name);
                            if (!header) {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <span>{item.rubro}</span>
                                        </td>
                                        <td>
                                            <Form.Control
                                                type='number'
                                                value={item.valor}
                                                name={item.name}
                                                onChange={(e) => handleValueChange(e.target.name, e.target.value)}
                                            />
                                        </td>
                                    </tr>
                                );
                            } // si no hay coincidencia, no renderizar// Suponemos orden correlativo
                            return (
                                <tr key={index}>
                                    <td>
                                        <TextWhitTooltip value={item.rubro} detail={header} />
                                    </td>
                                    <td>
                                        <CurrencyInput
                                            type={header.type === 'number' ? 'number' : 'text'}
                                            value={item.valor}
                                            name={item.name}
                                            onChange={(e) => handleValueChange(e.target.name, e.target.value)}
                                            readOnly={!header.editable}
                                            title={header.tooltip || ''}
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </Table>

            <Row className="mt-3">
                <Col className="text-start">
                    <Button variant="success" onClick={() => setShowModal(true)}>Agregar Rubro</Button>
                </Col>
                <Col className="text-end">
                    <Button variant="primary" onClick={handleSave}>Guardar</Button>
                </Col>
            </Row>

            {/* Modal de nuevo rubro */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Agregar Nuevo Rubro</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label>Descripción del Rubro</Form.Label>
                        <Form.Control
                            type="text"
                            value={newCiff.rubro}
                            onChange={(e) => setNewCiff({ ...newCiff, rubro: e.target.value })}
                            placeholder="Ej: Servicios generales"
                        />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Valor</Form.Label>
                        <Form.Control
                            type="number"
                            value={newCiff.valor}
                            onChange={(e) => setNewCiff({ ...newCiff, valor: e.target.value })}
                            placeholder="Ej: 50000"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>
                    <Button variant="success" onClick={handleAddNew}>
                        Agregar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default CostosFijosTable;